export const types = {
  FETCH_PART_FILE_CAD_DATA_ERROR:
    'common/viewer/cadViewer/partFileCadData/FETCH_PART_FILE_CAD_DATA_ERROR',
  FETCH_PART_FILE_CAD_DATA_INIT:
    'common/viewer/cadViewer/partFileCadData/FETCH_PART_FILE_CAD_DATA_INIT',
  FETCH_PART_FILE_CAD_DATA_SUCCESS:
    'common/viewer/cadViewer/partFileCadData/FETCH_PART_FILE_CAD_DATA_SUCCESS',
  PART_FILE_BULK_CAD_DATA_RECEIVE:
    'common/viewer/cadViewer/partFileCadData/PART_FILE_BULK_CAD_DATA_RECEIVE',
};

export const fetchPartFileCadStructure = {
  error: ({ partFileUuid }) => ({
    type: types.FETCH_PART_FILE_CAD_DATA_ERROR,
    payload: { partFileUuid },
  }),
  init: ({ partFileUuid }) => ({
    type: types.FETCH_PART_FILE_CAD_DATA_INIT,
    payload: { partFileUuid },
  }),
  success: ({ entities, partFileUuid, rootViewerBodyViewerId }) => ({
    type: types.FETCH_PART_FILE_CAD_DATA_SUCCESS,
    payload: {
      entities,
      partFileUuid,
      rootViewerBodyViewerId,
    },
  }),
};

export const partFileBulkCadData = {
  receive: ({ partFileUuids }) => ({
    type: types.PART_FILE_BULK_CAD_DATA_RECEIVE,
    payload: { partFileUuids },
  }),
};
